<template>
    <div class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'>运营</i></el-breadcrumb-item>
                <el-breadcrumb-item>兑换记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item label='项目'>
                                <el-select @change='handleSelectProject' clearable size='mini'
                                           v-model='queryParams.projectAppId' filterable placeholder='请选择'>
                                    <el-option
                                        v-for='item in projectInfoList'
                                        :key='item.appId'
                                        :label='item.cnName'
                                        :value='item.appId'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label='兑换状态'>
                                <el-select clearable size='mini' v-model='queryParams.status' filterable
                                           placeholder='请选择'>
                                    <el-option
                                        v-for='item in redeemStatusOptions'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            
                            <el-form-item label='礼包码'>
                                <el-input
                                    v-model='queryParams.code'
                                    placeholder='请输入礼包码'
                                    clearable
                                    size='mini'
                                    style='width: 180px'
                                />
                            </el-form-item>
                            
                            <el-form-item label='账号'>
                                <el-input
                                    v-model='queryParams.account'
                                    placeholder='请输入账号'
                                    clearable
                                    @change='handleBlurAccountInput'
                                    size='mini'
                                    style='width: 180px'
                                />
                            </el-form-item>
                            
                            <el-form-item label='批次'>
                                <el-input
                                    v-model='queryParams.codeCategoryTag'
                                    placeholder='请输入创建批次号'
                                    clearable
                                    size='mini'
                                    style='width: 180px'
                                />
                            </el-form-item>
                            
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='2'>
                        <el-statistic value-style='font-weight: bold' :value='queryParams.total' title='总兑换数'>
                            <template slot='prefix'>
                              <span class='like'>
                                <i
                                    class='el-icon-s-flag'
                                    style='color: #409EFF'
                                ></i>
                              </span>
                            </template>
                        </el-statistic>
                    </el-col>
                </el-row>
            </div>
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='redemptionRecordList'
                      @sort-change='handleSortChange'>
                <el-table-column label='礼包码' align='center'>
                    <template slot-scope='scope'>
                        <span>{{ scope.row.code }}</span>
                    </template>
                </el-table-column>
                <el-table-column label='兑换者' align='center'>
                    <template slot-scope='scope'>
                        <span v-if='!computeIsAccountUser(scope.row.userId)'>
                            <span>{{ scope.row.userId }}</span>
                            &nbsp;<span style='color: #409EFF;font-size: 10px'>单机</span>
                        </span>
                        <span v-else>
                            <span >{{ computeRealUserId(scope.row.userId) }}</span>
                            &nbsp;<el-button @click='handleQueryUserInfo(computeRealUserId(scope.row.userId))' type="text">查询</el-button>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label='兑换状态' align='center'>
                    <template slot-scope='scope'>
                        <el-tag v-if='scope.row.status === true' type="success">成功</el-tag>
                        <el-tag v-else type="danger">失败</el-tag>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label='兑换失败原因' align='center' prop='errorMsg' />
                <el-table-column show-overflow-tooltip label='礼包创建批次号' align='center'>
                    <template slot-scope='scope'>
                        <span>{{ scope.row.codeCategoryTag }}</span>
                    </template>
                </el-table-column>
                <el-table-column width='200' sortable='custom' label='创建时间' align='center' prop='createTime' />
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-sizes='[15, 30, 45, 60, 75, 100, 200, 300]'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='sizes, prev, pager, next'
                    @size-change='handleSizeChange'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改用户配置对话框 -->
            
            <el-dialog title='用户信息' :visible.sync='openShowUserInfoStatus' width='40%'>
                <el-form label-width='150'>
                    <el-form-item label='账号'>
                        <span>{{currentShowUserInfo.account}}</span>
                    </el-form-item>
                    <el-form-item label='邮箱'>
                        <span>{{currentShowUserInfo.email}}</span>
                    </el-form-item>
                    <el-form-item label='登录平台'>
                        <span>{{currentShowUserInfo.platform}}</span>
                    </el-form-item>
                    <el-form-item label='加入日期'>
                        <span>{{currentShowUserInfo.createTime}}</span>
                    </el-form-item>
                </el-form>
            </el-dialog>
            
        </div>
    </div>
</template>

<script>

import { pageUtil } from '@/utils/pageUtil';
import { message } from '@/utils/message';
import { projectInfoApi } from '@api/ProjectInfo';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import TrackDataFilter from '@/components/component/storage/TrackDataFilter.vue';
import { giftRedemptionRecordApi } from '@api/operation/giftCode/giftRedemptionRecord';
import { cottonUserApi } from '@api/Account/userCotton';

export default {
    name: 'User',
    components: {
        TrackDataFilter,
        VueJsonPretty
    },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                
                projectAppId: undefined,
                status: undefined,
                code: undefined,
                codeCategoryTag: undefined,
                account: undefined,
                userId: undefined
            },
            
            projectInfoList: [],
            
            openExportTrackData: false,
            exportTrackConfig: {
                pickerTimeValue: [],
                eventIdList: [],
                projectAppIdList: [],
                startTime: undefined,
                endTime: undefined,
                multiConditionExpress: {}
            },
            timePicker: {
                pickerTimeValue: [],
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近一个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近三个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近五个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ]
                }
            },
            redeemStatusOptions: [
                {
                    label: "成功",
                    value: true
                },
                {
                    label: "失败",
                    value: false
                }
            ],
            redemptionRecordList: [],
            openShowUserInfoStatus: false,
            currentShowUserInfo: {}
        };
    },
    computed: {
        computeIsAccountUser() {
            return userId => {
                return userId && userId.startsWith("userId_")
            }
        },
        computeRealUserId() {
            return userId => {
                return userId.substring("userId_".length)
            }
        }
    },
    created() {
        this.getList();
        this.initData();
    },
    methods: {
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        async handleSortChange({ column, prop, order }) {
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList);
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
            this.getList();
        },
        initData() {
            this.projectInfoList = [];
            projectInfoApi.query({ pageSize: 10000 }).then(result => {
                if (result.code === 200) {
                    this.projectInfoList = result.data.result;
                }
            });
        },
        getList() {
            this.loading = true;
            giftRedemptionRecordApi.query(this.queryParams).then(result => {
                if (result.code === 200) {
                    this.redemptionRecordList = result.data.result;
                    
                    this.queryParams.total = result.data.total;
                    this.queryParams.pageNum = result.data.pageNum;
                    this.queryParams.pageSize = result.data.pageSize;
                }
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ]
            };
            this.handleQuery();
        },
        resetQueryPage() {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
        
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
        
        },
        /** 删除按钮操作 */
        handleDelete(row) {
        
        },
        /** 提交按钮 */
        submitForm: function() {
        
        },
        handleSelectProject(projectAppId) {
        
        },
        handleQueryUserInfo(userId) {
            this.currentShowUserInfo = {}
            cottonUserApi.queryUserCotton({userId: userId}).then(result => {
                if (result.code === 200) {
                    let dataList = result.data.result
                    if (!dataList || dataList.length === 0) {
                        message.error(`用户${userId}不存在, 可能原因: 该账号已被注销！`)
                    }else {
                        this.openShowUserInfoStatus = true
                        this.currentShowUserInfo = dataList[0]
                    }
                }
            })
        },
        handleBlurAccountInput(account) {
            if (!account || account === '') {
                this.queryParams.userId = undefined;
                return;
            }
            cottonUserApi.queryUserCotton({account: account}).then(result => {
                if (result.code === 200) {
                    let dataList = result.data.result
                    if (dataList && dataList.length !== 0) {
                        this.queryParams.userId = "userId_" + dataList[0].userId
                    }else {
                        this.queryParams.userId = account;
                    }
                }
            })
        }
    }
};
</script>
